import { useState } from "react"
import PaiementModal from "../Modal/Modal"
import Pagination from "../Pagination"

export default function DerniersPaiement({data}){

    const [openModal, setOpenModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});

    const tableItems = [
        {
            avatar: "https://images.unsplash.com/photo-1511485977113-f34c92461ad9?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://randomuser.me/api/portraits/women/79.jpg",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
        {
            avatar: "https://images.unsplash.com/photo-1439911767590-c724b615299d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
            id: "PAI-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            client : 'Jean Mabiala',
            status: "Effectuée"
        },
    ]


    return (
        <div className="">
            <p className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">Derniers paiements</p>
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm ">
                <table className="w-full text-sm text-left table-auto bg-">
                    <thead className="font-medium text-gray-600 bg-gray-200 border-b border-gray-600 dark:text-gray-200 dark:bg-gray-800">
                        <tr>
                            <th className="px-6 py-3">Id</th>
                            <th className="px-6 py-3">ReservationId</th>
                            <th className="px-6 py-3">Client</th>
                            <th className="px-6 py-3">Annonce</th>
                            <th className="px-6 py-3">Date</th>
                            <th className="px-6 py-3">status</th>
                            
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left text-gray-700 transition bg-gray-200 border-gray-600 rounded cursor-pointer dark:text-gray-200 hover:bg-gray-200 duration-900 dark:bg-gray-800 dark:hover:text-gray-700" onClick={()=>{setOpenModal(true); setSelectedItem(item)}}>
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <div>
                                                    <span className="block text-sm font-medium ">{item.id}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.reservation.id}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.reservation.client.firstname}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.reservation.annonce.title}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                            {item.status === 0 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-gray-600 bg-gray-600  bg-opacity-15`}>
                                            {'En attente'}
                                            </span>}

                                            {item.status === 1 && <span className={`px-3 py-2 rounded-full font-semibold text-xs text-green-600 bg-green-600 bg-opacity-15`}>
                                            {'Effectué'}
                                            </span>}

                                            

                                            
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
            
            {openModal && <PaiementModal open={openModal} setOpen={setOpenModal} item={selectedItem}/>}

        </div>
    )
}